import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const AssetsExportContainer = styled('div')<{
    disabled: boolean
    theme?: TTheme
}>`
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    align-items: center;
    gap: 8px;

    .download-text {
        color: ${({ theme }) => theme.colors.primary[400]};
    }

    svg {
        color: ${({ theme }) => theme.colors.primary[400]};
    }

    &:hover {
        .download-text {
            color: ${({ theme }) => theme.colors.primary[500]};
        }
        svg {
            color: ${({ theme }) => theme.colors.primary[500]};
        }
    }
`
